'use strict';
module.exports = function attr(domElement, attrs) {
	Object.keys(attrs).forEach(key => {
		domElement.setAttribute(key, attrs[key]);
	});
};
